import { AxiosError } from 'axios'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface BackendErrorResponse {
  code: string
  message: string
}

interface GenericError extends AxiosError<BackendErrorResponse> {
  originURL: string
}

interface GenericErrorSSE {
  errorType: string
  message?: string
  name?: string
  error?: string
  code?: string
  data?: any
  statusCode?: string
  originURL?: string
  stack?: string
  payload?: string
}

interface GenericErrorStore {
  error?: GenericError
  errorSocket?: GenericErrorSSE
  sentryEventId?: string
  shouldRedirectToGenericError: boolean
  setSentryEventId(eventId: string): void
  setError(error): void
  setErrorSocket(error): void
  setShouldRedirectToGenericError(value: boolean): void
  resetError(): void
  resetErrorSocket(): void
}

export const useGenericErrorStore = create<GenericErrorStore>()(
  devtools(
    (set) => ({
      shouldRedirectToGenericError: false,
      setErrorSocket(error) {
        const parsedError: GenericErrorSSE = {
          ...error,
          originURL: window.location.href
        }

        set({ errorSocket: parsedError })
      },
      setSentryEventId(eventId) {
        set({ sentryEventId: eventId })
      },
      setError(error) {
        const parsedError: GenericError = {
          ...error,
          originURL: window.location.href
        }

        set({ error: parsedError })
      },
      setShouldRedirectToGenericError(value) {
        set({ shouldRedirectToGenericError: value })
      },
      resetError() {
        set({ error: undefined })
      },
      resetErrorSocket() {
        set({ errorSocket: undefined })
      }
    }),
    { name: 'useGenericErrorStore' }
  )
)
